import { makeAutoObservable } from "mobx";
import { Quantity } from "../core";
import { PCustomParameterInstanceId } from "./PCustomParameterInstanceId";
import { CreatorConfigValidation } from "./CreatorConfigValidation";
export class PCustomParameterInstanceCreator {
    constructor(params) {
        this.instanceId = new PCustomParameterInstanceId();
        this.domain = params.domain;
        this.customParameterInstanceAvailabilityService =
            params.customParameterInstanceAvailabilityService;
        this.customParameterType = params.customParameterType;
        this.creatorConfigValidation = new CreatorConfigValidation({
            hasError: () => this.availability.unavailabilityReasons.includes("Required"),
            minItems: Quantity.One,
            maxItems: Quantity.One,
        });
        makeAutoObservable(this);
    }
    get isVisible() {
        return this.choices.length > 0;
    }
    get typeId() {
        return this.domain.typeId;
    }
    get name() {
        return this.customParameterType.name;
    }
    get availability() {
        return this.customParameterInstanceAvailabilityService.availability(this.domain.customParameterInstance);
    }
    get choices() {
        return this.customParameterType.choices.objects.raw;
    }
    choiceAvailability(customParameterChoiceId) {
        return this.customParameterInstanceAvailabilityService.choiceAvailability(this.domain.customParameterType, customParameterChoiceId);
    }
    isSelected(customParameterChoiceId) {
        const { selectedChoice } = this.domain;
        return ((selectedChoice && selectedChoice.eq(customParameterChoiceId)) || false);
    }
    choose(customParameterChoiceId) {
        this.domain.choose(customParameterChoiceId);
        this.creatorConfigValidation.validate();
    }
    validate() {
        this.creatorConfigValidation.validate();
    }
}
